/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Shop } from '../pages/models/type/shop.model';
import firebase from 'firebase/compat/app';

@Injectable({
  providedIn: 'root',
})
export class ShopServiceService {
  constructor(private firestore: AngularFirestore) {}

  getStorePoints() {
    return this.firestore.collection('Store-Points').snapshotChanges();
  }

  getShops() {
    return this.firestore.collection('Store-Profile').snapshotChanges();
  }

  getShop(id) {
    return this.firestore.collection('Store-Profile').doc(id).get();
  }

  getOwnerShop(ownerID) {
    return this.firestore
      .collection('Store-Profile', (ref) => ref.where('ownerID', '==', ownerID))
      .get();
  }

  getShopProfile(ownerID) {
    return this.firestore.collection('Stores').doc(ownerID).get();
  }

  getShopProfiles() {
    return this.firestore.collection('Stores').get();
  }

  updateShopProfile(ownerID, shopDetails) {
    return this.firestore
      .collection('Stores')
      .doc(ownerID)
      .update({
        ...shopDetails,
      });
  }

  getShopOrders(shop) {
    const lowerCased = shop.toLowerCase();
    let capitalized = '';
    for (let i = 0; i < shop.length; i++) {
      if (i === 0) {
        capitalized += lowerCased[i].toUpperCase();
      } else {
        capitalized += lowerCased[i];
      }
    }

    // return this.firestore
    //   .collection('Orders', (ref) => ref.where('store', '==', shop))
    //   .snapshotChanges();
    return this.firestore
      .collection('Orders', (ref) =>
        ref.where('store', 'in', [lowerCased, capitalized])
      )
      .snapshotChanges();
  }

  setOrderCompletionTime(docID, minutes) {
    const acceptedByStoreAt = firebase.firestore.FieldValue.serverTimestamp();
    return this.firestore.collection('Orders').doc(docID).update({
      estimatedPreparationTime: minutes,
      status: 'store-accepted-order',
      acceptedByStoreAt,
    });
  }

  getOwnerDetails(userID) {
    return this.firestore.collection('Stores').doc(userID).get();
  }

  updateAddress(storeID) {
    return this.firestore.collection('');
  }
}
